import React, { Component } from 'react'

const SoldOutLingo = () => (
  <p>
    This restaurant has hit maximum order capacity which is established to
    ensure quality
  </p>
)

const pickMessage = (hurry, tooLate, soldOut, mealCount, orderPlaced) => {
  const hurryMessage = 'Hurry! Only %s meals left.'
  const tooLateMessage = "Bummer! You're late."
  const soldOutMessage = 'Sold Out!'
  if (soldOut) {
    return soldOutMessage
  } else if (tooLate) {
    return tooLateMessage
  } else if (hurry) {
    return hurryMessage.replace('%s', mealCount)
  }
  return null
}

class OrderStatus extends Component {
  render() {
    const { hurry, tooLate, soldOut, mealCount, orderPlaced } = this.props
    const message = pickMessage(hurry, tooLate, soldOut, mealCount, orderPlaced)
    return (
      <div className="col-xs-12 center-xs start-sm">
        {message && <span className="todaysstores-item_status">{message}</span>}
        {this.props.soldOut ? <SoldOutLingo /> : null}
      </div>
    )
  }
}

export default OrderStatus
